import React from 'react';
import Styled from 'styled-components';
import * as color from '../colors';
import ReviewCard from './../common/reviewCard';
import Button from './../common/button';

const Section = Styled.section.attrs((props) => ({ id: 'reviews' }))`
padding: 5rem 0;
background: ${color.primary};
}`;

const ReviewWrapper = Styled.div`
display: grid;
grid-template-columns: repeat(2, max-content);
place-items:center;
place-content:center;
grid-gap: 4rem;
margin: 4rem 0;
@media only screen and (max-width: 770px){
grid-template-columns: repeat(1, max-content);
}
`;

const Heading = Styled.h2`
color:${color.white};
text-align:center;
font-size: 4rem;
`;

const Footer = Styled.footer`
text-align:center;
`;

const Reviews = ({ items }) => {
  return (
    <Section>
      <Heading>Pets (and their humans) love us</Heading>
      <ReviewWrapper>
        {items.map((item) => (
          <ReviewCard
            key={item.name}
            image={item.image}
            heading={item.name}
            paragraph={item.paragraph}
          />
        ))}
      </ReviewWrapper>
      <Footer>
        <Button text={'View all Reviews'} type={'secondary'} rounded />
      </Footer>
    </Section>
  );
};

export default Reviews;
